import React from "react";
import { Link } from "react-router-dom";

const navTestId = (to) => to.replace(/\//g, "");

export default function RelatedPages({ pages, testId = "related-pages" }) {
  return (
    <section
      data-testid={testId}
      className="bg-warm border-t border-hairline px-5 md:px-10 py-14 md:py-20"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-[12px] tracking-[0.35em] uppercase text-gold mb-5 font-body">
            — Kapcsolódó oldalak
          </p>
          <h2 className="font-serif-display text-[28px] sm:text-[32px] md:text-[38px] leading-[1.2] text-graphite">
            Tovább{" "}
            <em className="text-gold" style={{ fontStyle: "italic" }}>
              olvasnál?
            </em>
          </h2>
        </div>
        <div
          className={`grid grid-cols-1 gap-5 md:gap-6 ${
            pages.length >= 3 ? "md:grid-cols-3" : "md:grid-cols-2 max-w-3xl mx-auto"
          }`}
        >
          {pages.map((p) => (
            <Link
              key={p.to}
              to={p.to}
              data-testid={`${testId}-card-${navTestId(p.to)}`}
              className="group bg-warm border border-hairline hover:border-[var(--accent-gold)] transition-colors duration-500 px-7 py-9 md:py-10 flex flex-col items-center text-center"
              style={{ boxShadow: "0 10px 40px -32px rgba(160, 122, 40, 0.22)" }}
            >
              <span className="font-serif-display text-[22px] md:text-[24px] leading-[1.3] text-graphite group-hover:text-gold transition-colors duration-300 mb-6">
                {p.label}
              </span>
              <span className="inline-flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-gold font-body pb-1 border-b border-[rgba(160,122,40,0.4)] group-hover:border-[var(--accent-gold)] transition-colors duration-300">
                Tovább
                <span aria-hidden="true" className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
